module.exports = __webpack_public_path__ + "static/img/bingfang.01cfd140.png";